<template>
    <div>
        <div class="card">
            <div class="card-body p-0">
                <div class="row d-flex align-items-center px-4 py-4 py-lg-0">
                    <div class="col-12 col-sm-6 col-lg-6 col-xl-4 mb-3 mb-lg-0 d-flex align-items-center">
                        <div>
                            <g-avatar :size="100" font-size="28" class="mr-4" :name="clientName" />
                        </div>
                        <div>
                            <h3 v-text="clientAlias" />
                            <h4 v-text="clientName" />
                        </div>
                    </div>

                    <div
                        class="col-12 col-sm-6 col-lg-6 col-xl-3 mb-3 mb-lg-0 d-flex d-sm-none d-xl-flex align-items-center"
                    >
                        <div>
                            <h4>Contacto</h4>

                            <span class="info-data mb-2">
                                <fa-icon :icon="['fal', 'mobile']" class="mr-1" />
                                <a v-if="client.mobile_phone" :href="`tel:${client.mobile_phone}`">{{
                                    client.mobile_phone
                                }}</a>
                                <span v-else class="text-muted">Sin definir</span>
                            </span>

                            <span class="info-data mb-2">
                                <fa-icon :icon="['fal', 'phone-office']" class="mr-1" />
                                <a v-if="client.phone" :href="`tel:${client.phone}`">{{ client.phone }}</a>
                                <span v-else class="text-muted">Sin definir</span>
                            </span>

                            <span class="info-data">
                                <fa-icon :icon="['fal', 'envelope']" class="mr-1" />

                                <a v-if="client.email" :href="`mailto:${client.email}`">{{ client.email }}</a>
                                <span v-else class="text-muted">Sin definir</span>
                            </span>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-lg-5 mb-0 d-flex align-items-center">
                        <client-sales :id="client._EntityId" />
                    </div>
                </div>

                <div class="row d-flex">
                    <div class="col-12 tabsTrigger">
                        <a-tabs
                            default-active-key="0"
                            :active-key="String(selectedTab)"
                            tab-position="bottom"
                            @change="(key) => (selectedTab = parseInt(key, 10))"
                        >
                            <a-tab-pane key="0">
                                <template #tab>
                                    <h5 class="mb-0" :class="[selectedTab === 0 ? 'text-primary' : '']">
                                        <fa-icon :icon="['fal', 'square-info']" class="mr-1" />
                                        General
                                    </h5>
                                </template>
                            </a-tab-pane>

                            <a-tab-pane key="1">
                                <template #tab>
                                    <h5 class="mb-0" :class="[selectedTab === 1 ? 'text-primary' : '']">
                                        <fa-icon :icon="['fal', 'cogs']" class="mr-1" />
                                        Configuración
                                    </h5>
                                </template>
                            </a-tab-pane>

                            <template #rightExtra>
                                <a-button>Right Extra Action</a-button>
                            </template>
                        </a-tabs>
                    </div>
                </div>
            </div>
        </div>

        <general-tab v-if="selectedTab == 0" :client="client" :loading="loading"> </general-tab>

        <form-tab v-if="selectedTab == 1" :id="id" :client="client" />

        <new-customer :id="0" :app="app" :view="view" :visible="formEnabled" @close="closeForm" />
    </div>
</template>

<script>
import newCustomer from '../form/index'
import GeneralTab from './tabs/general'
import FormTab from './tabs/form'

export default {
    name: 'ClientInfo',
    components: {
        newCustomer,
        GeneralTab,
        FormTab,
    },
    data() {
        return {
            app: 'clients',
            loading: false,
            client: {
                _EntityId: 0,
                alias: '',
                name: '',
                legal_name: '',
                payment_method: '',
                address: '',
                location: '',
                cp: '',
                rate: {
                    text: '',
                },
            },
            formEnabled: false,
            selectedTab: 0,
            fields: {
                payment_method: 0,
                show_prices: 0,
                surcharge: 0,
                iban: '',
                bic_swift: '',
                rate: '',
            },
        }
    },
    computed: {
        id() {
            return parseInt(this.$route.params.id, 10) || 0
        },
        view() {
            return `_clientWorks_${this.id}`
        },
        emptyClient() {
            return !this.client || !Object.keys(this.client).length
        },

        clientAlias() {
            return this.client.alias || ''
        },
        clientName() {
            return this.client.name || ''
        },
        clientLegalName() {
            return this.client.legal_name || ''
        },
        clientEmail() {
            if (this.emptyClient) return 'Sin definir'
            return this.client.email
        },
        clientPhone() {
            if (this.emptyClient || !this.client.phone) return 'Sin definir'
            return this.client.phone
        },
        clientMobile() {
            if (this.emptyClient || !this.client.mobile_phone) return 'Sin definir'
            return this.client.mobile_phone
        },
    },
    async created() {
        await this.getData()
        this.$hub.$on('newClient', () => {
            this.formEnabled = true
        })

        if (this.$route.query.edit) {
            setTimeout(() => {
                this.selectedTab = 1
            })
        }
    },
    beforeDestroy() {
        this.$hub.$off('newClient')
    },
    methods: {
        async getData() {
            this.loading = true

            const result = await this.$gestios.items('clients').get(this.id)

            if (result.ok) {
                this.client = result.data
                this.fields.payment_method = this.client.payment_method
                this.fields.show_prices = this.client.show_prices
                this.fields.surcharge = this.client.surcharge
                this.fields.iban = this.client.iban
                this.fields.bic_swift = this.client.bic_swift
                this.fields.rate = this.client.rate
            } else {
                this.$router.replace({ name: '_404' })
            }

            this.loading = false
        },
        openForm() {
            this.formEnabled = true
        },
        closeForm() {
            this.formEnabled = false
        },
        async save() {
            this.loading = true

            const data = await this.$gestios.items('clients').edit({
                id: this.id,
                params: {
                    ...this.fields,
                    rate: parseInt(this.fields.rate.key, 10) || null,
                },
            })

            if (data.ok) this.$gestios.$message.success('Cliente actualizado correctamente')

            this.loading = false
        },
    },
}
</script>

<style lang="scss" module>
@import './index.scss';
</style>

<style lang="scss">
.info-data {
    display: block;
    font-size: 14px;
    white-space: nowrap;

    svg {
        min-width: 24px;
    }
}
.active {
    color: red;
}
.pointer {
    cursor: pointer !important;
}
.tabsTrigger {
    margin-top: 0;
    padding-top: 0;

    & >>> div[role='tablist'] {
        margin-top: 0;
    }
}
</style>
